// extracted by mini-css-extract-plugin
export var button = "bN_pK";
export var button__darkBlue = "bN_pP";
export var button__edgesGrey = "bN_pQ";
export var button__edgesRed = "bN_pM";
export var button__loader = "bN_pR";
export var button__red = "bN_pL";
export var button__transparent = "bN_pN";
export var loadingSpinner = "bN_pS";